/**
 * One way to surface an engine error (web.md §10): plan limits and Pro-only features open the upsell
 * sheet ("Free includes 3 sources" + More → /subscribe); everything else is a toast with the error's
 * safe message. Limits are never re-implemented in the UI.
 */

import { toDigesterError, type DigesterErrorShape } from '@digester/core';
import { openDialog } from './dialogs.js';
import { showToast } from './Toast.js';

export function isPlanError(error: unknown): boolean {
  const code = toDigesterError(error).code;
  return code === 'plan_limit' || code === 'not_entitled';
}

/** Show `error` to the user. Returns the normalised shape (for callers that also render it inline). */
export function reportError(error: unknown): DigesterErrorShape {
  const e = toDigesterError(error);
  const shape = e.toShape();
  if (e.code === 'plan_limit' || e.code === 'not_entitled') openDialog('upsell', { error: shape });
  else showToast(e.message);
  return shape;
}

/** Run an engine call; report its error and resolve undefined instead of throwing. */
export async function attempt<T>(run: () => Promise<T>): Promise<T | undefined> {
  try {
    return await run();
  } catch (error) {
    reportError(error);
    return undefined;
  }
}
